import axios from 'axios'
import router from '@/router';
import {
	Message
} from "element-ui";
import { setLocalStorage, getLocalStorage, removeLocalStorage } from "../utils/localStorage"
import store from '@/store';
import  {myConfig} from "@/static/utils/lyconfig"
var baseURL = '';
if (process.env.NODE_ENV === 'development') { 
  baseURL = myConfig.testUrl
  myConfig.baseUrl = myConfig.testUrl
} else {
  baseURL = myConfig.baseUrl
}

let service = axios.create({
  baseURL: baseURL,
	validateStatus(status) {
	        return status >= 200 && status < 504 // 设置默认的合法的状态
	},
})
service.defaults.headers.common['Content-Type'] = 'application/json'

// request拦截器
service.interceptors.request.use(config => {
  config.headers.token = getLocalStorage("user-token")
  return config
}, error => {
  Promise.reject(error)
})

// respone拦截器
// service.interceptors.response.use(
//   response => {
//     return response
//   }, error => {
//     console.log(error)
//   }
// )
service.interceptors.response.use(
    response => {
        if (response.status !== 200) {
            if (response.status === 403){
								if(!store.state.isExpiry){
									Message.error('登录过期，请从新登录')
									store.commit('setIsExpiry',true)
								}
                localStorage.clear()
                // localStorage.removeItem('user-token')
								store.commit('setTag', []);
                router.replace({
                    path: '/'
                })
								
            }
            return Promise.reject(response)
        } else {
					if(response.data.state!==1&&response.data.state!==2){
						if(response.data.msg){
							if(response.data.msg == '无权限！'){
								router.replace({path:'/index'})
							}else{
								Message.error(response.data.msg)
							}
						}
					}
          return response
        }
    },error => {
        return Promise.reject(error)
    }
);
export default service
